import { useEffect } from 'react'

/**
 * useParallax
 * Runs a continuous RAF loop that lerps CSS custom properties --py-1 through --py-4
 * on :root. Section blobs apply transform: translateY(var(--py-N)) so they drift
 * at different speeds — the lerp gives a smooth trailing feel beyond raw scroll.
 */
export function useParallax() {
  useEffect(() => {
    const root = document.documentElement
    let raf = null

    // Lerped current values
    let c1 = 0, c2 = 0, c3 = 0, c4 = 0

    const tick = () => {
      const y = window.scrollY
      const ease = 0.09  // <1: trailing smoothness (lower = more trail)

      c1 += (y * 0.15 - c1) * ease
      c2 += (y * -0.11 - c2) * ease
      c3 += (y * 0.08 - c3) * ease
      c4 += (y * -0.06 - c4) * ease

      root.style.setProperty('--py-1', `${c1.toFixed(2)}px`)
      root.style.setProperty('--py-2', `${c2.toFixed(2)}px`)
      root.style.setProperty('--py-3', `${c3.toFixed(2)}px`)
      root.style.setProperty('--py-4', `${c4.toFixed(2)}px`)

      raf = requestAnimationFrame(tick)
    }

    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [])
}

